/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPrompt = createReactComponent("prompt", "IconPrompt", [
  ["path", { d: "M5 7l5 5l-5 5", key: "svg-0" }],
  ["path", { d: "M13 17l6 0", key: "svg-1" }]
]);

export { IconPrompt as default };
//# sourceMappingURL=IconPrompt.js.map
